import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from "../../lib/http";

export const fetchCustomers = createAsyncThunk('admin/fetchCustomers', async ({
                                                                                limit,
                                                                                offset,
                                                                                searchQuery
                                                                              }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/customers', { params: { limit, offset, searchQuery }});
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch contacts';
    return rejectWithValue(errorMessage);
  }
});
export const createCustomer = createAsyncThunk('admin/customers', async (userData, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/customers', userData);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create custom user';
    return rejectWithValue(errorMessage);
  }
});

export const editCustomer = createAsyncThunk('admin/editCustomer', async ({ customerId, userData }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/customers/${customerId}`, userData);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create custom user';
    return rejectWithValue(errorMessage);
  }
});

export const getCustomer = createAsyncThunk('admin/getCustomer', async (customerId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/customers/${customerId}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get customer data';
      return rejectWithValue(errorMessage);
    }
  }
);




const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    customers: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.contacts = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default adminSlice.reducer;
